// import { ShakaPlayerEngine } from '@24i/player-shaka-player';
import { DashJsPlayerEngine } from './ReactNativePlayerWeb/engine';

export const buildEngine = () => new DashJsPlayerEngine(); 
